import { Component, Output, EventEmitter } from '@angular/core';
import { BaseCreateBComponent } from '../../../libraries/base/create/base-create.bcomponent';
import { NewsCategoriesRestService } from '../news-categories-rest.service';

@Component({
  selector: 'app-news-categories-create',
  templateUrl: 'news-categories-create.component.html'
})
export class NewsCreateComponent extends BaseCreateBComponent {
  @Output() success: EventEmitter<boolean> = new EventEmitter();

  constructor(private _newsCategoriesRest: NewsCategoriesRestService) {
    super();
    this.componentId = 'NewsCreateComponent';
    this.routeURL = '/news-categories';
    this.entrySuccessI18n = 'success.categories.create';
    this.headerTitle = 'ui.categories.create.title';
  }

  appDefineFixedHooks() {
    super.appDefineFixedHooks();

    this.registerHook({
      hookName: 'save',
      handle: () => {
        const formValue = this.form.value;

        return this._newsCategoriesRest.create(formValue);
      },
      success: () => {
        this.success.emit(true);
      },
      wrapRetryableTask: true,
      wrapLoadingComponentIds: this.componentId,
      wrapErrorMessage: true
    });

    this.registerHook({
      hookName: 'init',
      handle: () =>
        this.page.compHookService.callMultipleHooks([
          'NewsCategoriesFormComponent:workflowBuildForm'
        ])
    });
  }

  appOnInit() {
    super.appOnInit();

    return this.callHook('init');
  }
}
